import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { formatINR, formatDate } from "@/lib/api";
import { Search, Users } from "lucide-react";

const Customers = () => {
  const [q, setQ] = useState("");
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const { data } = await api.get(`/customers${q ? `?q=${encodeURIComponent(q)}` : ""}`);
    setCustomers(data);
    setLoading(false);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  return (
    <div className="space-y-6" data-testid="customers-page">
      <div>
        <h1 className="text-2xl md:text-3xl font-bold text-slate-900" style={{ fontFamily: 'Poppins' }}>Customers</h1>
        <p className="text-sm text-slate-500">All customers auto-tracked from bills.</p>
      </div>

      <div className="qw-dash-card p-4 flex gap-3">
        <div className="relative flex-1"><Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"/>
          <input value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()} placeholder="Search by name or mobile…" className="qw-input pl-10" data-testid="customers-search"/>
        </div>
        <button onClick={load} className="qw-btn-primary">Search</button>
      </div>

      <div className="qw-dash-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 border-b text-xs uppercase text-slate-500">
            <tr><th className="text-left p-4">Customer</th><th className="text-left p-4">Mobile</th><th className="text-left p-4">Address</th><th className="text-right p-4">Orders</th><th className="text-right p-4">Spent</th><th className="text-left p-4">Last Visit</th></tr>
          </thead>
          <tbody>
            {loading ? Array.from({ length: 4 }).map((_, i) => <tr key={i}><td colSpan="6" className="p-3"><div className="h-8 bg-slate-100 rounded animate-pulse"/></td></tr>) :
             customers.length === 0 ? <tr><td colSpan="6" className="p-12 text-center text-slate-400" data-testid="customers-empty"><Users size={32} className="mx-auto text-slate-300 mb-2"/>No customers yet — they'll appear once you create bills.</td></tr> :
             customers.map((c) => (
              <tr key={c.mobile} className="border-b border-slate-100 hover:bg-slate-50" data-testid={`customer-row-${c.mobile}`}>
                <td className="p-4"><div className="font-semibold text-slate-900">{c.name}</div></td>
                <td className="p-4"><a href={`tel:${c.mobile}`} className="text-blue-600 hover:underline">{c.mobile}</a></td>
                <td className="p-4 text-slate-600 max-w-xs truncate">{c.address}</td>
                <td className="p-4 text-right font-semibold">{c.total_orders}</td>
                <td className="p-4 text-right font-semibold">{formatINR(c.total_spending)}</td>
                <td className="p-4 text-slate-500">{formatDate(c.last_visit)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Customers;
